export var AirPlayEvents;!function(a){a.AIR_PLAY_STATE_CHANGED="airplaystatechanged"}(AirPlayEvents||(AirPlayEvents={}));